import { fansupportPrivate } from "../index";

/**
 * Bir bildirimin durumunu gönderir.
 *
 * @param {string} notificationId - Bildirimin Id si
 * @returns {Promise<AxiosResponse>} - Bildirimin durumunu gönderme işlemin  sonucu
 */
export const getNotificationChangeStatus = async (notificationId) => {
    return fansupportPrivate.put('/notification/change-status', 0, {
        headers: {
            'Content-Type': 'application/json', // JSON formatını belirt
        },
        params: { notificationId } // notificationId sorgu parametresi olarak gönderiliyor
    });
}
